import SelectedItem from './SelectedItem';
import { SelectedListRoot } from './styles';
import type { RelatedApprovalItem } from './types';

type SelectedListProps = {
  items: RelatedApprovalItem[];
  onRemove: (docId: string) => void;
};

const SelectedList = ({ items, onRemove }: SelectedListProps) => {
  if (items.length === 0) return null;
  return (
    <SelectedListRoot>
      {items.map((item) => (
        <SelectedItem key={item.docId} item={item} onRemove={onRemove} />
      ))}
    </SelectedListRoot>
  );
};

export default SelectedList;
